module.exports = __webpack_public_path__ + "static/media/inlaws-male-perspective.d4185ae6.svg";